import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { FadeIn, Section, SectionTitle, Accent, pad2 } from './Shared';
import { Stars } from './HeaderSections';
import { OfferCard } from './CoreSections';
import { useCountdown } from '../hooks/useCountdown';
import { coachTestimonials } from '../data/testimonials';
import { faqs } from '../data/faqs';
import { ShieldCheck, Plus, Clock, Lock, CreditCard, ArrowRightIcon, MailIcon, AtSignIcon, MapPinIcon } from 'lucide-react';
export const Testimonials2 = () => <Section className="bg-slate-950" data-id="element-172" data-mp="13a4spyr151rp">
    <FadeIn data-id="element-173" data-mp="pgvpkftodchm">
      <SectionTitle sub={<span className="inline-flex flex-wrap items-center justify-center gap-2" data-id="element-175" data-mp="pgdieo5h5dux">
            <Stars size={14} data-id="element-176" data-mp="tgw9uh3gghwl" />
            <span className="font-semibold text-white" data-id="element-177" data-mp="tfuonjsq6f15">4.9/5</span>
            <span data-id="element-178" data-mp="1h70623ebdfdk">· +150 trainer in tutta Italia</span>
          </span>} data-id="element-174" data-mp="phf4dno13krf">
        Cosa dicono i <Accent data-id="element-179" data-mp="1m02z8af6imt8">coach</Accent>
      </SectionTitle>
    </FadeIn>

    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4" data-id="element-180" data-mp="31m4l804qx6mi">
      {coachTestimonials.map((t, i) => <FadeIn key={t.name} delay={Math.min(i * 0.05, 0.2)} data-id="element-181" data-mp="2wom77vbvg17n" data-mpi={i}>
          <figure className="flex h-full flex-col rounded-2xl border border-white/10 bg-white/[0.03] p-5" data-id="element-182" data-mp="3bch4lp0tqtr2">
            <Stars data-id="element-183" data-mp="36m0lppe8ifxb" />
            <blockquote className="mt-3 text-[15px] leading-relaxed text-slate-200" data-id="element-184" data-mp="36kplfzjzzqay">
              “{t.text}”
            </blockquote>
            <figcaption className="mt-auto flex items-center gap-3 pt-5" data-id="element-185" data-mp="3kbcaezzyi1tu">
              <div className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full ${t.bg} text-xs font-bold text-white`} data-id="element-186" data-mp="3gasaxprwum4j">
                {t.initials}
              </div>
              <div className="min-w-0" data-id="element-187" data-mp="3pbywid9f2n4n">
                <p className="text-sm font-semibold leading-tight text-white" data-id="element-188" data-mp="3pd1okoih6vm5">{t.name}</p>
                <p className="flex items-center gap-1 text-xs text-slate-500" data-id="element-189" data-mp="1zxtzbkz3dfgy">
                  <MapPinIcon size={11} aria-hidden="true" data-id="element-190" data-mp="1uziszk809n3h" /> {t.location} · Acquisto verificato
                </p>
              </div>
            </figcaption>
          </figure>
        </FadeIn>)}
    </div>
  </Section>;
export const Guarantee = () => <Section className="bg-slate-900/40" data-id="element-191" data-mp="7vr2u9yv8p33">
    <FadeIn className="mx-auto grid max-w-4xl items-center gap-8 rounded-3xl border border-emerald-500/25 bg-emerald-500/[0.05] p-6 md:grid-cols-[auto_1fr] md:gap-12 md:p-12" data-id="element-192" data-mp="7uptc9xi0anh">
      <div className="mx-auto flex h-28 w-28 items-center justify-center rounded-full border border-emerald-500/30 bg-emerald-500/10 md:h-36 md:w-36" data-id="element-193" data-mp="hugmo8abojlz">
        <div className="text-center" data-id="element-194" data-mp="mqx8uwxyonwf">
          <ShieldCheck size={36} className="mx-auto text-emerald-400" aria-hidden="true" data-id="element-195" data-mp="rj88dyosi7og" />
          <p className="mt-1 font-display text-2xl font-black italic leading-none text-white md:text-3xl" data-id="element-196" data-mp="vl3le0g329i2">7 giorni</p>
        </div>
      </div>
      <div className="text-center md:text-left" data-id="element-197" data-mp="10lr7q8tda25y">
        <h2 className="font-display text-3xl font-black uppercase italic leading-[0.95] tracking-tight text-white md:text-5xl" data-id="element-198" data-mp="15jj2rbpb64ed">
          Garanzia 7 giorni — <span className="text-emerald-400" data-id="element-199" data-mp="1fo95vkwg7ek6">senza domande</span>
        </h2>
        <div className="mt-5 space-y-3 text-base leading-relaxed text-slate-300 md:text-lg" data-id="element-200" data-mp="1ao3l8oolisbl">
          <p data-id="element-201" data-mp="15oqrdjzb4kzi">Apri i volumi. Usali nelle tue lezioni.</p>
          <p className="text-lg font-semibold leading-snug text-white md:text-xl" data-id="element-202" data-mp="15rcxrgagoug5">
            Se entro 7 giorni non è quello che ti aspettavi: rimborso al 100%.
          </p>
          <p data-id="element-203" data-mp="1ydftnmc3mwcu">Niente moduli. Niente complicazioni. Niente scuse.</p>
        </div>
        <p className="mt-5 text-xs font-semibold uppercase tracking-widest text-slate-500" data-id="element-204" data-mp="1tfw59tlot376">
          Tasso di rimborso: meno del 2%
        </p>
      </div>
    </FadeIn>
  </Section>;
export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="bg-slate-950" data-id="element-205" data-mp="2h4p3jwps7n4y">
      <div className="grid gap-10 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16" data-id="element-206" data-mp="2h5qfs4ijafo9">
        <FadeIn className="text-center lg:text-left" data-id="element-207" data-mp="2ccnt8gc6c6hk">
          <h2 className="font-display text-4xl font-black uppercase italic leading-[0.92] tracking-tight text-white md:text-6xl" data-id="element-208" data-mp="1wvp8cqvly700">
            Domande <Accent data-id="element-209" data-mp="21vtqsmg2tbsv">frequenti</Accent>
          </h2>
          <p className="mt-4 text-slate-400" data-id="element-210" data-mp="21sfpzin29anj">
            Hai ancora dubbi? Scrivici a{' '}
            <a href="mailto:soportecentershop95@gmail.com" className="font-medium text-sky-400 underline-offset-4 hover:underline" data-id="element-211" data-mp="1nx3rr19p521v">
              soportecentershop95@gmail.com
            </a>
          </p>
        </FadeIn>
        <FadeIn delay={0.05} data-id="element-212" data-mp="2kl0eknvq8tlj">
          <div className="divide-y divide-white/10 border-y border-white/10" data-id="element-213" data-mp="2kk8g95aqwhrk">
            {faqs.map((faq, i) => {
            const isOpen = openIndex === i;
            return <div key={faq.q} data-id="element-214" data-mp="2auoy61uuwrxr" data-mpi={i}>
                  <h3 data-id="element-215" data-mp="2atxdvn6pmgms">
                    <button id={`faq-q-${i}`} className="flex w-full items-center justify-between gap-4 py-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-400 rounded-md" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-a-${i}`} data-id="element-216" data-mp="2at4227sw90xs">
                      <span className="text-base font-semibold text-white md:text-lg" data-id="element-217" data-mp="11n5580465e6b">{faq.q}</span>
                      <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-[transform,background-color] duration-200 ease-out ${isOpen ? 'rotate-45 bg-blue-600 text-white' : 'bg-white/5 text-slate-300'}`} aria-hidden="true" data-id="element-218" data-mp="wmzcegm5xlmn">
                        <Plus size={16} data-id="element-219" data-mp="417u4ns4cb4e" />
                      </span>
                    </button>
                  </h3>
                  <AnimatePresence initial={false} data-id="element-220" data-mp="dxavvsj267qt">
                    {isOpen && <motion.div id={`faq-a-${i}`} role="region" aria-labelledby={`faq-q-${i}`} initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.22,
                  ease: [0.23, 1, 0.32, 1]
                }} className="overflow-hidden" data-id="element-221" data-mp="1ub9e0ui1e7d8">
                        <p className="pb-5 pr-12 text-[15px] leading-relaxed text-slate-300 md:text-base" data-id="element-222" data-mp="2bcdl27uywmeq">
                          {faq.a}
                        </p>
                      </motion.div>}
                  </AnimatePresence>
                </div>;
          })}
          </div>
        </FadeIn>
      </div>
    </Section>;
};
export const CostOfNotHaving = () => {
  const costs = [{
    sin: '3 ore a settimana a cercare sessioni',
    costo: '156 ore all’anno'
  }, {
    sin: 'Lezioni senza struttura',
    costo: 'Iscritti che abbandonano'
  }, {
    sin: 'Nessun adattamento per livello',
    costo: 'I nuovi iscritti non tornano'
  }, {
    sin: 'Nessun programma annuale',
    costo: 'Sempre gli stessi circuiti'
  }, {
    sin: 'Domeniche a cercare idee',
    costo: 'Lo stesso ciclo ogni anno'
  }];
  return <Section className="bg-slate-900/40" data-id="element-223" data-mp="397hkwkvn0jlg">
      <FadeIn className="mx-auto max-w-3xl" data-id="element-224" data-mp="394bwl7uu1lqs">
        <SectionTitle data-id="element-225" data-mp="3460mcw0ml981">
          Quanto ti costa
          <br data-id="element-226" data-mp="348wjii4nftvf" /> <Accent data-id="element-227" data-mp="2z7z3ab3799wk">non averlo?</Accent>
        </SectionTitle>

        <div className="overflow-hidden rounded-2xl border border-white/10 bg-white/[0.03]" data-id="element-228" data-mp="2z7gxamqqjhbg">
        <table className="w-full text-left" data-id="element-229" data-mp="2u9p65uxwzz8b">
          <thead data-id="element-230" data-mp="2pi7576vw5ync">
            <tr className="border-b border-white/10 bg-white/[0.04]" data-id="element-231" data-mp="2phnnnra5lc9u">
              <th scope="col" className="w-1/2 px-4 py-3.5 text-xs font-semibold uppercase tracking-wide text-slate-400 md:px-6 md:text-sm" data-id="element-232" data-mp="2pgchxlx5dug3">
                Senza Megapack Funzionale 365
              </th>
              <th scope="col" className="w-1/2 border-l border-white/10 px-4 py-3.5 text-xs font-semibold uppercase tracking-wide text-white md:px-6 md:text-sm" data-id="element-233" data-mp="2bieirnree4l6">
                Il costo reale
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-white/5" data-id="element-234" data-mp="3vek264q9x0c7">
            {costs.map(row => <tr key={row.sin} data-id="element-235" data-mp="39zl5kugpe7d">
                <td className="px-4 py-4 text-sm leading-snug text-slate-400 md:px-6 md:text-base" data-id="element-236" data-mp="38wwljkm3num">{row.sin}</td>
                <td className="border-l border-white/10 px-4 py-4 text-sm font-medium leading-snug text-red-400 md:px-6 md:text-base" data-id="element-237" data-mp="3lhff82olt0uc">
                  <span className="inline-flex items-start gap-1.5" data-id="element-238" data-mp="3bozsyt69xq3n">
                    <ArrowRightIcon size={14} className="mt-0.5 shrink-0 md:mt-1" aria-hidden="true" data-id="element-239" data-mp="3bnopyvknkmdl" />
                    {row.costo}
                  </span>
                </td>
              </tr>)}
          </tbody>
        </table>
        </div>

        <p className="mt-8 text-center text-lg font-semibold text-white md:text-xl" data-id="element-240" data-mp="37opq3pds3ft0">
          Il tuo prossimo allenamento può essere diverso…
        </p>
      </FadeIn>
    </Section>;
};
export const FinalCTA = () => {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <Section className="bg-slate-950 border-t border-white/5 !pb-28 md:!pb-24" data-id="element-241" data-mp="2e4zyvk1c57o5">
      <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-16" data-id="element-242" data-mp="2a2v58law0b1i">
        <FadeIn className="text-center lg:text-left" data-id="element-243" data-mp="2o24mzpeqrd7l">
          <h2 className="font-display text-4xl font-black uppercase italic leading-[0.92] tracking-tight text-white md:text-6xl" data-id="element-244" data-mp="2o2xkdzrt8qd2">
            Puoi <Accent data-id="element-245" data-mp="2j5e8h6il4poa">improvvisare</Accent> la tua prossima lezione — oppure entrare con tutto già risolto.
          </h2>
          <p className="mt-4 font-display text-3xl font-black uppercase italic text-sky-400 md:text-4xl" data-id="element-246" data-mp="2t1h7i3i54870">
            Decidi tu.
          </p>

          <div className="mt-8 inline-flex flex-col items-center gap-3 lg:items-start" data-id="element-247" data-mp="36rb08wwrncm0">
            <p className="inline-flex items-center gap-2 rounded-full bg-red-500/15 px-3 py-1 text-xs font-bold uppercase tracking-widest text-red-400" data-id="element-248" data-mp="31uklccwp6n26">
              <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-red-400" aria-hidden="true" data-id="element-249" data-mp="3brp8aeydamk1" />
              Ultima occasione · il prezzo scade tra
            </p>
            <p className="font-display text-5xl font-black tabular-nums leading-none tracking-tight text-white md:text-6xl" role="timer" aria-live="off" data-id="element-250" data-mp="3dz1y2bjclidx">
              {pad2(hours)}
              <span className="text-slate-600" data-id="element-251" data-mp="348qpgbopyl0p">:</span>
              {pad2(minutes)}
              <span className="text-slate-600" data-id="element-252" data-mp="307dk02pjgjub">:</span>
              {pad2(seconds)}
            </p>
            <p className="text-xs font-semibold uppercase tracking-widest text-slate-500" data-id="element-253" data-mp="q5w6bue83rr">
              Poi sale. E non tornerà più a questo prezzo.
            </p>
          </div>

          <ul className="mt-8 hidden flex-wrap gap-x-6 gap-y-2 text-sm text-slate-400 lg:flex" data-id="element-254" data-mp="3nvex7oxnwog2">
            <li className="flex items-center gap-2" data-id="element-255" data-mp="3ixd74k1tjov3"><Lock size={14} aria-hidden="true" data-id="element-256" data-mp="3iwbs64homi83" /> Pagamento sicuro al 100%</li>
            <li className="flex items-center gap-2" data-id="element-257" data-mp="2chsybc2038hc"><Clock size={14} aria-hidden="true" data-id="element-258" data-mp="2ceopg1dlbokc" /> Accesso in 5 minuti</li>
            <li className="flex items-center gap-2" data-id="element-259" data-mp="27g3ou0uff2vd"><ShieldCheck size={14} aria-hidden="true" data-id="element-260" data-mp="mzmf1vaxib5d" /> Garanzia 7 giorni</li>
            <li className="flex items-center gap-2" data-id="element-261" data-mp="mxjewig2b1mx"><CreditCard size={14} aria-hidden="true" data-id="element-262" data-mp="ry7e3reg2os8" /> Carta di credito · Debito · Pagamento in euro</li>
          </ul>
        </FadeIn>

        <FadeIn delay={0.05} className="mx-auto w-full max-w-md" data-id="element-263" data-mp="vyrc0x6udwff">
          <OfferCard id="final-offer" footnote="Pagamento unico · Garanzia 7 giorni inclusa" data-id="element-264" data-mp="10rkcv9z6wkm8" />
        </FadeIn>

        <ul className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-slate-400 lg:hidden" data-id="element-265" data-mp="15p2gckufu7mu">
          <li className="flex items-center gap-1.5" data-id="element-266" data-mp="1ao5j1ymy41rn"><Lock size={13} aria-hidden="true" data-id="element-267" data-mp="1ar1khwy058ku" /> Pagamento sicuro al 100%</li>
          <li className="flex items-center gap-1.5" data-id="element-268" data-mp="1fotecwi7j4ro"><Clock size={13} aria-hidden="true" data-id="element-269" data-mp="1jpmz5h0cs3gc" /> Accesso in 5 minuti</li>
          <li className="flex items-center gap-1.5" data-id="element-270" data-mp="1jnsnktaz1nox"><ShieldCheck size={13} aria-hidden="true" data-id="element-271" data-mp="3hg6c91lrcce8" /> Garanzia 7 giorni</li>
          <li className="flex w-full items-center justify-center gap-1.5" data-id="element-272" data-mp="3lh9vly30kqk7"><CreditCard size={13} aria-hidden="true" data-id="element-273" data-mp="3lhrw56wplqxx" /> Carta di credito · Debito · Pagamento in euro</li>
        </ul>
      </div>
    </Section>;
};
export const Footer = () => <footer className="border-t border-white/5 bg-slate-950 px-5 py-12 md:px-8" data-id="element-274" data-mp="noq7q8wsd0ew">
    <div className="mx-auto flex max-w-6xl flex-col gap-8 md:flex-row md:items-start md:justify-between" data-id="element-275" data-mp="11nze6gv6wg5o">
      <div className="max-w-sm text-center md:text-left" data-id="element-276" data-mp="xlmjcnhze2no">
        <p className="font-display text-xl font-black uppercase italic tracking-tight text-white" data-id="element-277" data-mp="xo8ropcp4m6y">
          Megapack Funzionale <Accent data-id="element-278" data-mp="16mu4e3vhl6zt">365™</Accent>
        </p>
        <p className="mt-1 text-xs font-semibold uppercase tracking-widest text-slate-500" data-id="element-279" data-mp="16lrgm4tgnko4">
          di Center Shop Digital
        </p>
        <p className="mt-4 text-sm leading-relaxed text-slate-400" data-id="element-280" data-mp="1ld9r5n3jwn03">
          Il sistema n.1 di lezioni pronte da insegnare per istruttori e coach
          di allenamento funzionale. Perché tenere una grande lezione non
          dovrebbe costarti tutte le domeniche dell’anno.
        </p>
      </div>
      <div className="flex flex-col items-center gap-3 text-sm text-slate-400 md:items-end" data-id="element-281" data-mp="1pb7l1389nx9t">
        <a href="mailto:soportecentershop95@gmail.com" className="inline-flex items-center gap-2 transition-colors duration-150 hover:text-white" data-id="element-282" data-mp="28x10cejy76fi">
          <MailIcon size={14} aria-hidden="true" data-id="element-283" data-mp="1zx467xeshfd2" /> soportecentershop95@gmail.com
        </a>
        <a href="#" className="inline-flex items-center gap-2 transition-colors duration-150 hover:text-white" data-id="element-284" data-mp="23yzghrep732z">
          <AtSignIcon size={14} aria-hidden="true" data-id="element-285" data-mp="1q7b3zn0jeclh" /> centershop.digital
        </a>
      </div>
    </div>
    <div className="mx-auto mt-10 flex max-w-6xl flex-col items-center gap-3 border-t border-white/5 pt-6 text-xs text-slate-500 md:flex-row md:justify-between" data-id="element-286" data-mp="1uzul2tyfnpv1">
      <p className="text-center md:text-left" data-id="element-287" data-mp="1l8zuxei2g64b">
        © {new Date().getFullYear()} Center Shop Digital. Tutti i diritti riservati.
        Prezzi in euro (EUR).
      </p>
      <p className="flex gap-4" data-id="element-288" data-mp="17bui8vnuk903">
        <a href="#" className="transition-colors duration-150 hover:text-white" data-id="element-289" data-mp="1c930ew8zwd1c">Termini e Condizioni</a>
        <a href="#" className="transition-colors duration-150 hover:text-white" data-id="element-290" data-mp="1485632jxutxy">Privacy Policy</a>
      </p>
    </div>
  </footer>;